import { IMediaItem } from 'types/media'
import { isTextMediaItem } from 'utils'

/** Per stored `zIndex` (timeline row): compact height for text-only rows, full otherwise. */
export const buildHeightByZIndexForVisualRows = (
  mediaItems: IMediaItem[],
  fullRowHeight: number,
  compactRowHeight: number
): Map<number, number> => {
  const byZ = new Map<number, IMediaItem[]>()
  for (const item of mediaItems) {
    const list = byZ.get(item.zIndex) ?? []
    list.push(item)
    byZ.set(item.zIndex, list)
  }
  const heights = new Map<number, number>()
  for (const [zIndex, rowItems] of byZ) {
    const textOnly =
      rowItems.length > 0 && rowItems.every(m => isTextMediaItem(m.type))
    heights.set(zIndex, textOnly ? compactRowHeight : fullRowHeight)
  }
  return heights
}
